import { th } from 'style/theme';
import styled from 'styled-components';
import { Input } from 'components/Inputs';

export const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin: 0;
  background-color: ${th('colors.pickledBluewood4')};
  border-radius: 16px;
  padding: 12px 25px;
  margin-bottom: 16px;

  > ${Input} {
    border: none;
    padding: 0;
    margin: 0;
  }

  > svg {
    color: ${th('colors.black')};
  }
`;
